import { render, staticRenderFns } from "./McuCard.vue?vue&type=template&id=67f2808a&"
import script from "./McuCard.vue?vue&type=script&lang=ts&"
export * from "./McuCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports